/**
 * @param  {Array<T>} elements
 * @returns Map
 */
export function arrayToMap<T extends { id: number }>(
  elements: Array<T>
): { [key: number]: T } {
  const ret = {};
  for (const key in elements) {
    if (Object.prototype.hasOwnProperty.call(elements, key)) {
      const element = elements[key];
      ret[element.id] = element;
    }
  }
  return ret;
}

/**
 * @param  {Map<number} elements
 * @returns Map
 */
export function mapToArray<T extends { id: number }>(elements: {
  [key: number]: T;
}): Array<T> {
  const ret = new Array<T>();
  for (const key in elements) {
    if (Object.prototype.hasOwnProperty.call(elements, key)) {
      const element = elements[key];
      ret.push(element);
    }
  }

  return ret;
}

export const getInitials = function (fullName: string) {
  const names = fullName.split(" ");
  let initials = names[0].substring(0, 1).toUpperCase();

  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase();
  }
  return initials;
};
